import { Component, Input, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { SelectOptionDto } from 'shared-lib';
import { TransmissionStation } from 'shared-lib';
import { SubstationCrud } from 'shared-lib';
import { F11Crud } from '../../models/feeder11.model';
import { F33Crud } from '../../models/f33.model';
import { Feeder11Service } from 'shared-lib';
import { Feeder33Service } from 'shared-lib';
import { TransmissionStationService } from 'shared-lib';
import { SubstationService } from 'shared-lib';
import { NetworkAssetTypes } from '../../enums/network-asset-types.enum';
import { DtForSelect } from '../../models/dt.model';
import { Edge, Node } from 'ngx-vflow';
import {
  IdGuidDto,
  NetworkAssetCountsDataOut,
  NetworkAssetListDataIn,
  NetworkAssetsCountDataIn,
} from '../../models/network-asset.model';
import { NetworkAssetService } from '../../services/network-asset.service';
import { MoreOptionsService } from '../../services/moreOptions.service';
import { NetworkAssetNodeComponent } from '../common/network-asset-node/network-asset-node.component';
import { LogicalTreeRequest } from '../../models/logical-tree-request.model';
import { MapConfig } from '../../models/mapConfig.model';
import { MAP_THEMES } from '../../models/mapOptions.model';

@Component({
  selector: 'app-network-assets',
  templateUrl: './network-assets.component.html',
  styleUrls: ['./network-assets.component.scss'],
  standalone: false,
})
export class NetworkAssetsComponent implements OnInit {
  nodes: Node[] = [];
  edges: Edge[] = [];
  @Input() isFromAdvancedMap: boolean = false;
  @Input() isFromLegacyMap: boolean = false;
  @Input() defaultConfig: MapConfig = new MapConfig(19);

  mapOptions: any = {
    ...(MAP_THEMES.find((t) => t.key == 'retro')?.mapOptions ?? {}),
    mapTypeId: 'roadmap',
    gestureHandling: 'none',
    zoomControl: false,
    streetViewControl: false,
    mapTypeControl: false,
    rotateControl: false,
    fullscreenControl: false,
    disableDoubleClickZoom: true,
    keyboardShortcuts: false,
    tilt: 0,
  };

  selectedAssetOptions: SelectOptionDto[] = [];
  searchTerm: string = ''; // For the search term
  clicked: boolean = false;
  selectedItem?: SelectOptionDto;
  dropdownOpen: boolean = false;

  tss: TransmissionStation[] = [];
  substations: SubstationCrud[] = [];
  feeder11s: F11Crud[] = [];
  feeder33s: F33Crud[] = [];
  dts: DtForSelect[] = [];
  topEmployee: any;
  hierarchy: any;
  statistics: NetworkAssetCountsDataOut[] = [];
  filteredAssets: any[];
  selectedAsset?: NetworkAssetTypes | null = null;
  parentId: number = 0;
  excludeIds: number[] = [];
  borderColor: string = '';
  modalHeader: string = '';
  // selectedAsset?: NetworkAssetTypes;
  assetList = [
    {
      id: 1,
      name: 'Transmission Station',
      cardName: 'TS',
      value: NetworkAssetTypes.TS,
      svgPath: 'assets/icons/transmission.svg',
      borderColor: 'rgba(192, 52, 56, 0.2)',
      count: 0,
    },
    {
      id: 2,
      name: 'Main Feeder',
      cardName: '33KV',
      value: NetworkAssetTypes.F33KV,
      svgPath: 'assets/icons/main-feeder.svg',
      borderColor: 'rgba(0, 71, 255, 0.2)',
      count: 0,
    },
    {
      id: 3,
      name: 'Injection Substation',
      cardName: 'SS',
      value: NetworkAssetTypes.SS,
      svgPath: 'assets/icons/substations.svg',
      borderColor: 'rgba(237, 99, 0, 0.2)',
      count: 0,
    },
    {
      id: 4,
      name: 'Secondary Feeder',
      cardName: '11KV',
      value: NetworkAssetTypes.F11KV,
      svgPath: 'assets/icons/secondary-feeders.svg',
      borderColor: 'rgba(151, 71, 255, 0.2)',
      count: 0,
    },
    {
      id: 5,
      name: 'Distribution Substation',
      cardName: 'DT',
      value: NetworkAssetTypes.DT,
      svgPath: 'assets/icons/transformers.svg',
      borderColor: 'rgba(96, 149, 27, 0.2)',
      count: 0,
    },
  ];

  assetKeys = [
    'SELECT_TS_ASSET',
    'SELECT_33KV_ASSET',
    'SELECT_INJSS_ASSET',
    'SELECT_11KV_ASSET',
    'SELECT_DT_ASSET',
  ];

  selectedAssetId?: number;
  selectedIdsFromViewMore: number[] = [];
  public networkAssetTypes: NetworkAssetTypes = NetworkAssetTypes.F33KV;
  public viewMoreAssetType: NetworkAssetTypes;
  public parentNetworkAssetTypes: NetworkAssetTypes = NetworkAssetTypes.TS;
  showMore: Boolean = false;
selectedAssetFilterItem: { id: number; name: string } | null = null;

  constructor(
    private tsService: TransmissionStationService,
    private f11Service: Feeder11Service,
    private f33Service: Feeder33Service,
    private substationService: SubstationService,
    private toastr: ToastrService,
    private networkAssetService: NetworkAssetService,
    private moreOptionsService: MoreOptionsService
  ) {}

  ngOnInit(): void {
    this.selectedAssetFilterItem = this.assetTypeItems[0]; 
    this.getAssetsCount();
    this.subscribeToListener();
  }

  get assetTypeItems() {
    return [
      { id: 0, name: 'All Assets' },
      ...this.assetList.map((a) => ({ id: a.value, name: a.name })),
    ];
  }

get selectedAssetTypeItem() {
  if (this.selectedAsset === null || this.selectedAsset === undefined) {
    return this.assetTypeItems[0]; 
  }

  return (
    this.assetTypeItems.find(
      (i: any) => i.id === this.selectedAsset
    ) ?? this.assetTypeItems[0]
  );
}

  handleSelectedItem(e: any) {
    this.selectedItem = e;
    if (!this.selectedItem) {
      this.nodes = [];
      this.edges = [];
    }
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  selectAssetItem(asset: any) {
    this.selectedAsset = asset?.value ?? null;
    this.selectAsset();
    this.selectedItem = asset
      ? ({ id: asset.value, name: asset.name } as any)
      : undefined;
    this.dropdownOpen = false;
  }

onAssetFilterSelected(item: any) {
  this.selectedAssetFilterItem = item;
  this.selectedIdsFromViewMore = [];
  this.nodes = [];
  this.edges = [];
    this.selectedItem = undefined;

  if (item.id === 0) {
    this.selectedAsset = null;
    this.applyAllAssetsTree();
    return;
  }

  this.selectedAsset = item.id as NetworkAssetTypes;
  this.selectAsset();
  this.openSelectItemDropdown();
}

  onAssetFilterApply() {
    if (!this.selectedAssetFilterItem) return;

    this.selectedIdsFromViewMore = [];
    this.nodes = [];
    this.edges = [];
    this.selectedItem = undefined;

    if (this.selectedAssetFilterItem.id === 0) {
      this.selectedAsset = null;
      this.applyAllAssetsTree();
      return;
    }

    this.selectedAsset = this.selectedAssetFilterItem.id as NetworkAssetTypes;
    this.selectAsset();
    this.openSelectItemDropdown();
  }


  applyAllAssetsTree() {
    const request = {
      id: 0,
      type: this.selectedAsset as any,
      viewMore: {
        ids: [],
        type: this.viewMoreAssetType,
      },
    } as LogicalTreeRequest;

    this.networkAssetService.getLogicalTree(request).subscribe(
      (data: any) => {
        this.edges = data.body.data.edges;
        this.nodes = data.body.data.nodes;
        this.nodes.forEach((x) => (x.type = NetworkAssetNodeComponent));
      },
      (error: any) => {
        console.log(error);
      }
    );
  }
  reloadTree(event: any) {
    this.selectedIdsFromViewMore = event;
    // this.selectedAsset = this.networkAssetTypes;
    // this.getSelectedItemFromModal();
    // this.setFilterWhenModalSelected();
    this.applyFilter(1);
  }
  subscribeToListener() {
    this.moreOptionsService.currentNode.subscribe((obj) => {
      this.parentId = obj.parentId;
      this.excludeIds = obj.excludeIds;
      this.viewMoreAssetType = this.getType(obj.type);
      this.networkAssetTypes = this.getType(obj.type);
      this.parentNetworkAssetTypes = this.getType(obj.parentType);
      this.borderColor = obj.borderColor;
      this.modalHeader = this.getModalHeader(obj.type);
      this.showMore = true;
    });
  }
  getType(type: any) {
    if (type == 'TS') return NetworkAssetTypes.TS;
    if (type == 'F33KV') return NetworkAssetTypes.F33KV;
    if (type == 'SS') return NetworkAssetTypes.SS;
    if (type == 'F11KV') return NetworkAssetTypes.F11KV;
    if (type == 'DT') return NetworkAssetTypes.DT;
    return NetworkAssetTypes.TS;
  }
  getModalHeader(type: any) {
    if (type == 'TS') return 'Transmission Stations';
    if (type == 'F33KV') return 'Feeder 33 kV';
    if (type == 'SS') return 'Substations';
    if (type == 'F11KV') return 'Feeder 11 kV';
    if (type == 'DT') return 'Distribution Substations';

    return '';
  }
  setFilterWhenModalSelected() {
    switch (this.selectedAsset) {
      case NetworkAssetTypes.TS:
        this.selectedAssetOptions = [
          ...this.tss
            .slice(0, 9)
            .map((ts) => ({ id: ts.id, name: ts.name, checked: false })),
        ];
        break;

      case NetworkAssetTypes.F33KV:
        this.selectedAssetOptions = [
          ...this.feeder33s
            .slice(0, 9)
            .map((f33) => ({ id: f33.id, name: f33.name, checked: false })),
        ];
        break;

      case NetworkAssetTypes.SS:
        this.selectedAssetOptions = [
          ...this.substations
            .slice(0, 9)
            .map((ss) => ({ id: ss.id, name: ss.name, checked: false })),
        ];
        break;

      case NetworkAssetTypes.F11KV:
        this.selectedAssetOptions = [
          ...this.feeder11s
            .slice(0, 9)
            .map((f11) => ({ id: f11.id, name: f11.name, checked: false })),
        ];
        break;

      case NetworkAssetTypes.DT:
        this.selectedAssetOptions = [
          ...this.dts.slice(0, 9).map((dt) => ({
            id: dt.externalId,
            name: dt.name,
            checked: false,
          })),
        ];
        break;

      default:
        this.selectedAssetOptions = [];
        break;
    }
  }
  applyFilter(e: any) {
    if (this.selectedItem) {
      var request = this.createRequestObject();

      this.networkAssetService.getLogicalTree(request).subscribe(
        (data: any) => {
          this.edges = data.body.data.edges;
          this.nodes = data.body.data.nodes;
          this.nodes.forEach((x) => (x.type = NetworkAssetNodeComponent));
        },
        (error: any) => {
          console.log(error);
        }
      );
    }
  }

  createRequestObject() {
    var obj = {
      id: this.selectedItem?.id,
      type: this.selectedAsset,
      viewMore: {
        ids: this.selectedIdsFromViewMore,
        type: this.viewMoreAssetType,
      },
    } as LogicalTreeRequest;

    return obj;
  }

  applySearchFilter(e: any) {
    const searchTerm = e.toLowerCase();

    switch (this.selectedAsset) {
      case NetworkAssetTypes.TS:
        this.selectedAssetOptions = this.tss
          .filter((x) => x.name.toLowerCase().includes(searchTerm))
          .slice(0, 10)
          .map((ts) => ({ id: ts.id, name: ts.name, checked: false }));
        break;

      case NetworkAssetTypes.F33KV:
        this.selectedAssetOptions = this.feeder33s
          .filter((x) => x.name.toLowerCase().includes(searchTerm))
          .slice(0, 10)
          .map((f33) => ({ id: f33.id, name: f33.name, checked: false }));
        break;

      case NetworkAssetTypes.SS:
        this.selectedAssetOptions = this.substations
          .filter((x) => x.name.toLowerCase().includes(searchTerm))
          .slice(0, 10)
          .map((ss) => ({ id: ss.id, name: ss.name, checked: false }));
        break;

      case NetworkAssetTypes.F11KV:
        this.selectedAssetOptions = this.feeder11s
          .filter((x) => x.name.toLowerCase().includes(searchTerm))
          .slice(0, 10)
          .map((f11) => ({ id: f11.id, name: f11.name, checked: false }));
        break;

      case NetworkAssetTypes.DT:
        this.selectedAssetOptions = this.dts
          .filter((x) => x.name.toLowerCase().includes(searchTerm))
          .slice(0, 10)
          .map((dt) => ({ id: dt.externalId, name: dt.name, checked: false }));
        break;

      default:
        this.selectedAssetOptions = [];
        break;
    }
  }

  getAssetsCount() {
    this.getTsCount();
    this.getfeeder33Count();
    this.getfeeder11Count();
    this.getSubstationsCount();
    this.getDtsCount();
  }

  selectAsset() {
    this.nodes = [];
    this.edges = [];

    switch (this.selectedAsset) {
      case NetworkAssetTypes.TS:
        this.selectedAssetOptions = this.tss
          .slice(0, 10)
          .map((ts) => ({ id: ts.id, name: ts.name, checked: false }));
        break;

      case NetworkAssetTypes.F33KV:
        this.selectedAssetOptions = this.feeder33s
          .slice(0, 10)
          .map((f33) => ({ id: f33.id, name: f33.name, checked: false }));
        break;

      case NetworkAssetTypes.SS:
        this.selectedAssetOptions = this.substations
          .slice(0, 10)
          .map((ss) => ({ id: ss.id, name: ss.name, checked: false }));
        break;

      case NetworkAssetTypes.F11KV:
        this.selectedAssetOptions = this.feeder11s
          .slice(0, 10)
          .map((f11) => ({ id: f11.id, name: f11.name, checked: false }));
        break;

      case NetworkAssetTypes.DT:
        this.selectedAssetOptions = this.dts
          .slice(0, 10)
          .map((dt) => ({ id: dt.externalId, name: dt.name, checked: false }));
        break;

      default:
        this.selectedAssetOptions = [];
        break;
    }
  }

  filterAssets() {
    this.selectedAssetId = undefined;
    this.filteredAssets = this.searchTerm
      ? this.feeder33s
          .filter((asset) =>
            asset.name.toLowerCase().includes(this.searchTerm.toLowerCase())
          )
          .slice(0, 10)
      : this.feeder33s.slice(0, 10);

    this.filteredAssets = this.filteredAssets.map((f33) => ({
      name: f33.name,
      value: f33.id,
    }));
  }
  getSelectedItemFromModal() {
    switch (this.selectedAsset) {
      case NetworkAssetTypes.TS:
        this.selectedItem = this.tss
          .map((ss) => ({ id: ss.id, name: ss.name, checked: false }))
          .find((ts) => ts.id == this.selectedAssetId);
        break;
      case NetworkAssetTypes.F33KV:
        this.selectedItem = this.feeder33s
          .map((ss) => ({ id: ss.id, name: ss.name, checked: false }))
          .find((f33) => f33.id == this.selectedAssetId);
        break;
      case NetworkAssetTypes.SS:
        this.selectedItem = this.substations
          .map((ss) => ({ id: ss.id, name: ss.name, checked: false }))
          .find((ss) => ss.id == this.selectedAssetId);
        break;
      case NetworkAssetTypes.F11KV:
        this.selectedItem = this.feeder11s
          .map((f11) => ({ id: f11.id, name: f11.name, checked: false }))
          .find((f11) => f11.id == this.selectedAssetId);
        break;
      case NetworkAssetTypes.DT:
        this.selectedItem = this.dts
          .map((dt) => ({ id: dt.externalId, name: dt.name, checked: false }))
          .find((dt) => dt.id == this.selectedAssetId);
        break;
      default:
        this.selectedItem = undefined;
        break;
    }
  }
  createRequestParams(
    list: IdGuidDto[],
    type: NetworkAssetTypes
  ): NetworkAssetListDataIn {
    const requestObject = {
      dataIn: list.map((x) => ({
        id: x.id,
        guid: x.guid,
        networkAssetType: type,
      })) as NetworkAssetsCountDataIn[],
    };

    return requestObject;
  }

  getNetworkAssetCounts(dataIn: NetworkAssetListDataIn) {
    this.networkAssetService.getNetworkAssetCounts(dataIn).subscribe(
      (data: any) => {
        this.statistics = data.body.data;
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  getTsCount() {
    this.tsService.getAllForSelect().subscribe(
      (data) => {
        this.tss = data.body.data;
        const asset = this.assetList.find(
          (item) => item.name === 'Transmission Station'
        );
        if (asset) {
          asset.count = this.tss.length;
        }
      },
      (error) => {
        this.toastr.error('Error occured');
      }
    );
  }

  getfeeder33Count() {
    this.f33Service.getAllForSelect().subscribe(
      (data) => {
        this.feeder33s = data.body!.data;
        this.filterAssets();
        this.feeder33s.forEach((item) => {
          item.guid = crypto.randomUUID();
        });

        const asset = this.assetList.find(
          (item) => item.name === 'Main Feeder'
        );
        if (asset) {
          asset.count = this.feeder33s.length;
        }
      },
      (error) => {
        this.toastr.error('Error occured');
      }
    );
  }

  getfeeder11Count() {
    this.f11Service.getAllForSelect().subscribe(
      (data) => {
        this.feeder11s = data.body.data;

        this.feeder11s.forEach((item) => {
          item.guid = crypto.randomUUID(); // Assign a new GUID to each item
        });

        const asset = this.assetList.find(
          (item) => item.name === 'Secondary Feeder'
        );
        if (asset) {
          asset.count = this.feeder11s.length;
        }
      },
      (error) => {
        this.toastr.error('Error occured');
      }
    );
  }

  getSubstationsCount() {
    this.substationService.getAllForSelect().subscribe({
      next: (data) => {
        this.substations = data.body.data;

        this.substations.forEach((item) => {
          item.guid = crypto.randomUUID(); // Assign a new GUID to each item
        });

        const asset = this.assetList.find(
          (item) => item.name === 'Injection Substation'
        );
        if (asset) {
          asset.count = this.substations.length;
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  getDtsCount() {
    this.networkAssetService.getTaggedDtsForSelect().subscribe(
      (data: any) => {
        this.dts = data.body.data;
        const asset = this.assetList.find(
          (item) => item.name === 'Distribution Substation'
        );
        if (asset && data.body) {
          asset.count = data.body.data.length;
        }
      },
      (error: any) => {
        this.toastr.error('Error occured');
      }
    );
  }

  getFilteredAssets() {
    switch (this.selectedAsset) {
      case NetworkAssetTypes.TS:
        return this.tss.map((ts) => ({ name: ts.name, value: ts.id }));
      case NetworkAssetTypes.SS:
        return this.substations.map((ss) => ({ name: ss.name, value: ss.id }));
      case NetworkAssetTypes.F11KV:
        return this.feeder11s.map((f11) => ({ name: f11.name, value: f11.id }));
      case NetworkAssetTypes.F33KV:
        this.filteredAssets = [
          ...this.feeder33s
            .slice(0, 10)
            .map((f33) => ({ name: f33.name, value: f33.id })),
        ];
        return this.filteredAssets.map((f33) => ({
          name: f33.name,
          value: f33.id,
        }));
      case NetworkAssetTypes.DT:
        return this.dts.map((dt) => ({ name: dt.name, value: dt.externalId }));
      default:
        return this.assetList;
    }
  }

  selectAssetFromHierarchy(id: number) {
    this.selectedAsset = id as NetworkAssetTypes;
    this.selectedAssetFilterItem =
      (this.assetTypeItems as any[]).find((i: any) => i.id === this.selectedAsset) ?? null;
    this.selectAsset();
    this.openSelectItemDropdown();
  }

  private openSelectItemDropdown() {
    this.clicked = false;
    setTimeout(() => {
      this.clicked = true;
      setTimeout(() => (this.clicked = false), 0);
    }, 0);
  }
}
